<template>
  <div class="loading">
    <div class="loading__indicator"></div>
    <p class="loading__text">Please Wait</p>
  </div>
</template>

<script>
export default {
  name: 'loading',
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/scss/settings.scss";

  .loading {
    text-align: center;
  }

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }

  .loading__indicator {
    width: 33px;
    height: 33px;
    border: 3px solid #eee;
    border-top-color: #000;
    border-radius: 100%;
    margin: 10px auto;
    animation: spin 500ms linear infinite;
  }
</style>
